import { GridCellBaseComponent } from '../cells/grid-cell-base/grid-cell-base.component';
import { Type } from '@angular/core';
import { GridCellTextComponent } from '../cells/grid-cell-text/grid-cell-text.component';
import { GridCellDateComponent } from '../cells/grid-cell-date/grid-cell-date.component';
import { GridCellNumericComponent } from '../cells/grid-cell-numeric/grid-cell-numeric.component';
import { TableFieldDataType } from 'src/models/ts/table-field-data-type.model';
import { GridCellCheckboxComponent } from '../cells/grid-cell-checkbox/grid-cell-checkbox.component';
import { GridCellEnumComponent } from 'src/app/shared/components/grid/cells/grid-cell-enum/grid-cell-enum.component';
import { GridCellMemoComponent } from 'src/app/shared/components/grid/cells/grid-cell-memo/grid-cell-memo.component';
import { GridCellCanvasComponent } from 'src/app/shared/components/grid/cells/grid-cell-canvas/grid-cell-canvas.component';
import { GridCellMacroButtonComponent } from 'src/app/shared/components/grid/cells/grid-cell-macrobutton/grid-cell-macro-button.component';

export const GRID_CELL_TABLE_FIELD_COMPONENT_TYPES: { [K in TableFieldDataType]: Type<GridCellBaseComponent<unknown>> } = {
  [TableFieldDataType.None]: GridCellTextComponent,
  [TableFieldDataType.AlphaNumeric]: GridCellTextComponent,
  [TableFieldDataType.Numeric]: GridCellNumericComponent,
  [TableFieldDataType.Email]: GridCellTextComponent,
  [TableFieldDataType.DatePicker]: GridCellDateComponent,
  [TableFieldDataType.TimePicker]: GridCellTextComponent, //DEPRECATED, unimplemented
  [TableFieldDataType.DateTimePicker]: GridCellDateComponent,
  [TableFieldDataType.Checkbox]: GridCellCheckboxComponent,
  [TableFieldDataType.RadioGroup]: GridCellEnumComponent,
  [TableFieldDataType.Combobox]: GridCellEnumComponent,
  [TableFieldDataType.Memo]: GridCellMemoComponent,
  [TableFieldDataType.OrganizationChartUnitSelector]: GridCellTextComponent,
  [TableFieldDataType.ControlledDocument]: GridCellTextComponent,
  [TableFieldDataType.MacroButton]: GridCellMacroButtonComponent,
  [TableFieldDataType.HyperLink]: GridCellTextComponent,
  [TableFieldDataType.PdfFile]: GridCellTextComponent,
  [TableFieldDataType.Canvas]: GridCellCanvasComponent,
  [TableFieldDataType.OrganizationChartUnitSelectorForTrnApp]: GridCellTextComponent,
  [TableFieldDataType.ExamCreator]: GridCellTextComponent,
  [TableFieldDataType.ExamScoreEvaluations]: GridCellTextComponent,
  [TableFieldDataType.MailingList]: GridCellTextComponent,
  [TableFieldDataType.AiButton]: GridCellTextComponent,
  [TableFieldDataType.ChkResultClassValues]: GridCellTextComponent,
  [TableFieldDataType.ChkQuestionsCreateEditModus]: GridCellTextComponent,
  [TableFieldDataType.ChkQuestionsExecuteModus]: GridCellTextComponent,
  [TableFieldDataType.EnumList]: GridCellEnumComponent,
  [TableFieldDataType.TextValue]: GridCellTextComponent,
  [TableFieldDataType.SimpleList]: GridCellTextComponent,
  [TableFieldDataType.TimeRange]: GridCellTextComponent //TODO: RV implement GridCellTimeRangeComponent
};